import MainTxtElements from './main-txt-elements';
export default MainTxtElements;
